// extracted by mini-css-extract-plugin
export default {"wrapper":"VerifyAddress_style_wrapper__lLEy1","heading":"VerifyAddress_style_heading__x9hp+","rotate":"VerifyAddress_style_rotate__Ye9VC"};